import { get } from '@/util/helpers/ajax-helpers';
import { loading, completed } from './helpers';
import {
  MAP_VISIBLE_TABLES_LOADED,
  MAP_VISIBLE_TABLES_UPDATED,
  MAP_SCALE_UPDATED,
} from './constants';
import MapsTable from '../util/MapsTable';

export function loadVisibleTables() {
  return (dispatch) => {
    dispatch(loading(MAP_VISIBLE_TABLES_LOADED));
    get('loading list of visible tables', '/maps').then((json) => {
      const visibleTables = json.tables.map((t) => MapsTable.build(t));
      dispatch(
        completed(MAP_VISIBLE_TABLES_LOADED, {
          visibleTables,
        }),
      );
    });
  };
}

export function updateVisibleTables(visibleTables, rebuildMap) {
  return completed(MAP_VISIBLE_TABLES_UPDATED, {
    visibleTables,
    updateMapKey: rebuildMap,
  });
}

export function updateScale(scale) {
  return completed(MAP_SCALE_UPDATED, {
    scale,
  });
}
